import script from "./GameDetailFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./GameDetailFooter.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./GameDetailFooter.vue?vue&type=style&index=0&id=39e1abd0&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../../apps/evankao/game-yiyouwang/yywfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__